import {setLikedItem} from '@api/item';
import Tippy from '@tippyjs/react';
import {useTheme} from 'next-themes';
import React, {useState} from 'react';
import {useApp} from '../providers/app-provider';

const Likes = ({
  like,
  classes = 'dark:bg-white dark:bg-opacity-30 absolute top-3 right-3 flex items-center space-x-1 rounded-md bg-white p-2 cursor-pointer',
  id,
  isLiked,
}: {
  like: number;
  classes?: string;
  id?: number;
  isLiked?: boolean;
}) => {
  const {jwt: token, setLoginShow} = useApp();
  const [likeNumber, setlikeNumber] = useState(like);
  const [IsLikedItem, setisLikedItem] = useState(isLiked);
  const {theme} = useTheme();

  const handleLikeItem = async () => {
    if (token) {
      const item = await setLikedItem(Number(id));
      if (item && item.statusCode !== 401) {
        setisLikedItem(true);
        setlikeNumber((prev) => prev + 1);
      } else {
        setisLikedItem(false);
        setlikeNumber((prev) => prev - 1);
      }
      return item;
    } else {
      setLoginShow && setLoginShow(true);
    }
  };

  return (
    <div className={classes} onClick={handleLikeItem}>
      <Tippy content={<span className="p-2">Favorite</span>}>
        <button className="js-likes relative cursor-pointer h-4 w-4">
          {!IsLikedItem ? (
            <img
              className="h-4 w-4"
              src="/images/icons/icon-like-transparent.svg"
              alt="Icon Like Transparent"
            />
          ) : (
            <img
              className="h-4 w-4"
              src={
                theme === 'light'
                  ? `/images/icons/icon-like.svg`
                  : `/images/icons/icon-like-dark.svg`
              }
              alt="Icon Like Fill"
            />
          )}
        </button>
      </Tippy>
      <span className=" dark:text-white text-black text-sm cursor-pointer">{likeNumber}</span>
    </div>
  );
};

export default Likes;
